import { recipientConstants } from '../constants';
import { saveParams, deleteParams, createParams } from './base.reducers';

const name = 'recipients';

const initialState = {
	saveLoading: 0,
	saveSuccess: false,
	deleteLoading: 0,
	allLoading: 0,

	recipients: [],
	recipientsById: {}
};

export default (state = initialState, payload) => {
	const { type, data } = payload;
	switch (type) {
		// Save and edit recipients
		case recipientConstants.SAVING_RECIPIENT_REQUEST:
			return {
				...state,
				saveSuccess: false,
				saveLoading: state.saveLoading + 1,
			};
		case recipientConstants.SAVING_RECIPIENT_SUCCESS:
			const { form } = data;
			return {
				...saveParams({ name, state, form }),
				saveLoading: state.saveLoading - 1,
				saveSuccess: true,
			};
		case recipientConstants.SAVING_RECIPIENT_FAILURE:	
			return {
				...state,
				saveLoading: state.saveLoading - 1,
			};
		// Delete recipient
		case recipientConstants.DELETE_RECIPIENT_REQUEST:
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		case recipientConstants.DELETE_RECIPIENT_SUCCESS:
			const id = data;
			return {
				...deleteParams({ name, state, id }),
				deleteLoading: state.deleteLoading - 1
			};
		case recipientConstants.DELETE_RECIPIENT_FAILURE:	
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		// Load recipients
		case recipientConstants.LOAD_RECIPIENTS_REQUEST:
			return {
				...state,
				allLoading: state.allLoading + 1,
			};
		case recipientConstants.LOAD_RECIPIENTS_SUCCESS:
			return {
				...createParams({ name, state, data: data.data }),
				allLoading: state.allLoading - 1,
			};
		case recipientConstants.LOAD_RECIPIENTS_FAILURE:	
			return {
				...state,
				allLoading: state.allLoading - 1,
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/redux/reducers/recipient.reducers.js